// 滚动重置工具函数

/**
 * 强制滚动到顶部的函数
 * 使用多种方法确保滚动重置成功，检查所有可能的滚动容器
 */
export function forceScrollToTop() {
  // 方法1: 重置主要滚动容器
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
  window.scrollTo(0, 0)
  window.scrollTo({ top: 0, behavior: 'instant' })

  // 检查并重置所有可滚动的元素
  const scrollableElements = document.querySelectorAll('*')
  scrollableElements.forEach(element => {
    if (element.scrollTop > 0) {
      element.scrollTop = 0
    }
  })

  // 特别检查常见的滚动容器
  const commonScrollContainers = [
    '#app',
    '.app',
    'main',
    '.main',
    '.content',
    '.page-content',
    '.router-view'
  ]

  commonScrollContainers.forEach(selector => {
    const element = document.querySelector(selector)
    if (element && element.scrollTop > 0) {
      element.scrollTop = 0
    }
  })

  // 方法2: 使用requestAnimationFrame确保执行
  requestAnimationFrame(() => {
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    window.scrollTo(0, 0)
    window.scrollTo({ top: 0, behavior: 'instant' })
  })

  // 方法3: 延迟确保
  setTimeout(() => {
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    window.scrollTo(0, 0)
    window.scrollTo({ top: 0, behavior: 'instant' })
  }, 100)
}

/**
 * 页面组件滚动重置组合式函数
 * 在组件挂载时自动执行滚动重置
 */
export function useScrollReset(pageName = '页面') {
  const { onMounted } = require('vue')
  
  onMounted(() => {
    console.log(`📄 ${pageName}组件挂载，执行滚动重置`)
    
    // 立即执行
    forceScrollToTop()
    
    // 延迟执行确保组件完全渲染
    setTimeout(() => {
      console.log(`📄 ${pageName}延迟滚动重置`)
      forceScrollToTop()
    }, 50)
    
    setTimeout(() => {
      console.log(`📄 ${pageName}最终滚动重置`)
      forceScrollToTop()
    }, 200)
  })
}

/**
 * 监听路由变化并重置滚动的组合式函数
 */
export function useRouteScrollReset() {
  const { watch } = require('vue')
  const { useRoute } = require('vue-router')
  
  const route = useRoute()
  
  watch(() => route.fullPath, (newPath, oldPath) => {
    if (newPath !== oldPath) {
      console.log('🔄 路由变化滚动重置:', { from: oldPath, to: newPath })
      forceScrollToTop()
    }
  })
}

/**
 * 全局滚动重置函数
 * 可以在任何地方调用
 */
export function setupGlobalScrollReset() {
  // 挂载到window对象
  window.forceScrollToTop = forceScrollToTop

  // 挂载到document对象
  document.forceScrollToTop = forceScrollToTop
}
